import React, { useCallback, useEffect, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { DatePicker } from '@mui/x-date-pickers';
import Grid from '@mui/material/Grid2';
import Dialog from '@mui/material/Dialog';
import Drawer from '@mui/material/Drawer';
import { Checkbox, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, MenuItem, Select, Tooltip } from '@mui/material';
import dayjs from 'dayjs';
import { regionalFields } from 'pages/OcplcEditDashboard/OcplcEditColumns/columnTypes';
import { copyRegionForMaterialAvailability, createCopyAvailability, getRegionalWWDates, updateMaterialAvailability, updateServiceAvailability, updateModelAvailability, updateDefaultLocalization, updateAvailabilityLocalization, GetDefaultFeatureDropDown, GetDefaultFeatureValueDropDown, updateTOFProgramManagement, GetParameters, GetParametersDropdown, updateLocChoiceId, GetLocChoiceName, GetLocChoiceValue, GetParametersLocDropdown, updateLocMapping, getRegionalCheckBox } from 'actions/ocplcAction';
import { useDispatch, useSelector } from 'react-redux';
import { getDateRange, isRegionalLockDisabled, updateCountryData } from 'pages/Utils/OcplcUtil';
import { OCPLC_KE_OTHER_REGIONAL, OCPLC_REGIONAL, OCPLC_READ_ONLY, ROLE_NAME_FOR_KE, DUMMY_DATE, INVALID_COMMENTS, DISABLE_WW_DATES, MATERIAL_AVAILABILITY, OCPLC_ADMIN, MODEL_AVAILABILITY_TABLE, DEFAULT_LOC, LOC_AVAILABILITY, TOF_AUDIT_TRAIL, TOF_PROGRAM_MANAGEMENT, VERSION_0003, LOC_CHOICE_ID, LOC_MAPPING, INVALID_COMMENTS_FOR_MATERIAL, DISABLE_LOC, COMPLETE_WARNING_MESSAGE } from 'constants/ocplcConstants';
import { useStyles } from '../../ocplcDashboard/ocplcHelpers';
import ConfirmationDialog from 'components/ConfirmationDialog';

const EditOcplc = (props) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { open, handleClose, plcDetails, countryList, businessModels, userEmail, selectedTableRegion, disabledAction, assignedRole, kmatId, productLineID, copy, setCheckedRows, selectedTable, selectedCategory, productGroupDashboard, setSelectedIds, getFormData, getConfirmationDialog} = props;
    const { version, region, choiceId, material, materialDesc, localization, regionLock, country, countryDesc, productFamily, productDesc, businessModel, whenChanged, lastModifiedDate, createDate, productGroup, status, comments, ms4StartDate, ms4EndDate, startDate, endDate, wwAutoStartDate, wwAutoEndDate, whoChanged, apRegion, laRegion, euRegion, naRegion, wwStartDate, wwEndDate, autoStart, autoEnd, feature, featureValue, locFeature, locFeatureValue, featureDesc, regStartDate, regEndDate, parameterKey, parameterValue, parameterText, logicalLock, pkId } = plcDetails || {};
    const [formData, setFormData] = useState({});
    const defaultFeatureDropdown = useSelector((state) => state.ocplc?.defaultFeatureDropdown);
    const localizationChoice = useSelector((state) => state.ocplc?.localizationChoice);
    const localizationChoiceValue = useSelector((state) => state.ocplc?.localizationChoiceValue);
    const defaultFeatureValueDropdown = useSelector((state) => state.ocplc?.defaultFeatureValueDropdown);
    const parametersDropdown = useSelector((state) => state.ocplc?.parametersDropdown);
    const localizationMapping = useSelector((state) => state.ocplc?.localizationMapping);
    const filterOcplcKmatForPG = useSelector((state) => state?.ocplc?.filterOcplcKmatForPG);
    const regionalCheckBoxValues = useSelector((state) => state.ocplc?.regionalCheckboxes || {});
    const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(true);
    const [localizationError, setLocalizationError] = useState("");
    const [confirmDialog,setConfirmationDialog] = useState({open: false, message: '', onConfirm: null});
    const regionForCopyAndEdit = copy ? selectedTableRegion : region;
    const isMaterialAvailability = selectedTable === MATERIAL_AVAILABILITY;
    const isModelAvailability = selectedTable === MODEL_AVAILABILITY_TABLE;
    const isServiceAvailability = selectedTable === "Factory Services";
    const isDefaultLocalization = selectedTable === DEFAULT_LOC;
    const isAvailabiltyLocalization = selectedTable === LOC_AVAILABILITY;
    const isTOFPM = selectedTable === TOF_PROGRAM_MANAGEMENT;
    const isLocChoiceId = selectedTable === LOC_CHOICE_ID;
    const isLocMapping = selectedTable === LOC_MAPPING;
    const isDatesForCopy = (copy && selectedTableRegion !== "WW") || (!copy && region !== "WW");
    const isDatesForCopyAndEdit = (!copy && region === "WW") || (copy && selectedTableRegion === "WW");
    const isTableRegionWW = selectedTableRegion !== "WW" && region === "WW";
    const isWwRegion = regionForCopyAndEdit === "WW";
    const startDateValue = selectedTableRegion === "WW" ? dayjs(endDate).format().startsWith(DUMMY_DATE) ? DUMMY_DATE: startDate :dayjs(wwEndDate).format().startsWith(DUMMY_DATE) ? DUMMY_DATE : wwStartDate;
    const endDateValue = selectedTableRegion === "WW" ? dayjs(startDate).format().startsWith(DUMMY_DATE) ? DUMMY_DATE: endDate : dayjs(wwStartDate).format().startsWith(DUMMY_DATE) ? DUMMY_DATE : wwEndDate;
    const isRegionalAndReadonly = assignedRole === OCPLC_READ_ONLY || (!isServiceAvailability && assignedRole === OCPLC_REGIONAL)
    const isOcplcKE = !(isAvailabiltyLocalization || isTOFPM)  && (assignedRole === ROLE_NAME_FOR_KE && selectedTableRegion !== "WW");
    const isOtherRegion = assignedRole.startsWith(OCPLC_KE_OTHER_REGIONAL) && isAvailabiltyLocalization
    const isRegional = assignedRole.startsWith(OCPLC_KE_OTHER_REGIONAL) && region === "WW";
    const isDisabledMatField = !copy && isMaterialAvailability && comments.includes(INVALID_COMMENTS_FOR_MATERIAL) // Disable all fields for Material Availability if comments have COMMENT-TO-BLOCK-EDITING-FROM-UI
    const isFieldDisabled = !copy && (disabledAction || isTableRegionWW || isRegionalAndReadonly || isOcplcKE || isRegional );
    const isLogicalLock = logicalLock !==0 && selectedTable === MATERIAL_AVAILABILITY && !copy;
    const isCheckDisabled = disabledAction || isTableRegionWW || isRegionalAndReadonly || isRegional || isCheckboxDisabled || isServiceAvailability || isLogicalLock;
    const invalidStartDates = dayjs(endDate || wwEndDate).format().startsWith(DUMMY_DATE) ? DUMMY_DATE : regStartDate || startDate || formData?.wwStartDate || wwStartDate;
    const invalidEndDates = dayjs(startDate || wwStartDate).format().startsWith(DUMMY_DATE) ? DUMMY_DATE : regEndDate || endDate || formData?.wwEndDate || wwEndDate;
    const isLocalization = isDefaultLocalization || isAvailabiltyLocalization;
    const isVersionRestricted = version === VERSION_0003
    const isTOFPMRegionalDisabled = !copy && isTOFPM && !(assignedRole === OCPLC_ADMIN || assignedRole === ROLE_NAME_FOR_KE);
    const isAdminOrKE = (isLocMapping || isLocChoiceId) && !(assignedRole === OCPLC_ADMIN || assignedRole === ROLE_NAME_FOR_KE);
    const isOtherMaterialRegion = selectedTable === MATERIAL_AVAILABILITY && selectedTableRegion !== 'WW';
    const isKERole = assignedRole === ROLE_NAME_FOR_KE && isServiceAvailability;
    const isKERoleForDefaultLoc = assignedRole === ROLE_NAME_FOR_KE && isDefaultLocalization;
    
    const isDatesInvalid = [formData?.wwStartDate, formData?.wwEndDate, formData?.regStartDate, formData?.regEndDate].some(date =>
        dayjs(date).format().startsWith(DUMMY_DATE)
    );
    const isWWDatesInvalid = [formData?.wwStartDate, formData?.wwEndDate,].some(date =>
        dayjs(date).format().startsWith(DUMMY_DATE)
    );
    const isWwDatesValid = [formData?.regStartDate, formData?.regEndDate].some(date =>
        dayjs(date).format().startsWith(DUMMY_DATE)
    );
    const isMS4MaterialDatesInvalid = (isModelAvailability || isMaterialAvailability) && [ms4StartDate, ms4EndDate, autoStart, autoEnd].some(date =>
        dayjs(date).format().startsWith(DUMMY_DATE)
    );
    const isMS4SeriviceDatesInvalid = isServiceAvailability && [wwAutoStartDate, wwAutoEndDate].some(date =>
        dayjs(date).format().startsWith(DUMMY_DATE)
    );
    const isWwDatesDummy = [formData?.startDate, formData?.endDate].some(date =>
        dayjs(date).format().startsWith(DUMMY_DATE)
    );

    const readOnlyFields = comments.startsWith(INVALID_COMMENTS) && !copy
    const [isInsertDisabled, setIsInsertDisabled] = useState(false);
    const authenticatedUser = whoChanged === userEmail;
    const isWwStartDateEdited = !dayjs(plcDetails?.startDate).isSame(dayjs(formData?.startDate), 'day');
    const isWwEndDateEdited = !dayjs(plcDetails?.endDate).isSame(dayjs(formData?.endDate), 'day');
    const isRegStartDateEdited = !dayjs(copy ? plcDetails.wwStartDate : plcDetails?.startDate).isSame(dayjs(formData?.regStartDate), 'day');
    const isRegEndDateEdited = !dayjs(copy ? plcDetails.wwEndDate : plcDetails?.endDate).isSame(dayjs(formData?.regEndDate), 'day');
    const isWWDatesDisabled = comments.includes(DISABLE_WW_DATES) // Disable WW Dates if comments have MS4_PLC_SYNC;
    const isLocExcluded = isAvailabiltyLocalization && comments.includes(DISABLE_LOC) // Disable Localization if comments have COMMENT-TO-BLOCK-EDITING-FROM-UI;
    const isAnyRegionChecked = !!formData.ap || !!formData.eu || !!formData.la || !!formData.na;
    const shouldDisableAllRegions = isAvailabiltyLocalization && isAnyRegionChecked;// In Availability Localization, disable all checkboxes if any is checked

    const pseriesDateFields = regionalFields.flatMap(({ startField, startName, endField, endName }) => [
        plcDetails[startName] && {
            label: plcDetails[startName] || startName,
            id: startField,
            type: 'date',
            minDate: dayjs(getDateRange(formData?.regStartDate, wwStartDate)),
            maxDate: dayjs(getDateRange(formData?.regEndDate, wwEndDate)),
            disabled: disabledAction || isRegionalAndReadonly || isOcplcKE || isDatesInvalid || readOnlyFields || isDisabledMatField,
            value: plcDetails[startField] ? dayjs(plcDetails[startField]) : null,
            hide: !copy && region === "WW",
            tooltip: true
        },
        plcDetails[endName] && {
            label: plcDetails[endName] || endName,
            id: endField,
            disabled: disabledAction || isRegionalAndReadonly || isOcplcKE || isDatesInvalid || readOnlyFields || isDisabledMatField,
            type: 'date',
            minDate: dayjs(getDateRange(formData?.regStartDate, wwStartDate)),
            maxDate: dayjs(getDateRange(formData?.regEndDate, wwEndDate)),
            value: plcDetails[endField] ? dayjs(plcDetails[endField]) : null,
            hide: !copy && region === "WW",
            tooltip: true
        },
    ]).filter(Boolean);
    
    const renderFields = [
        { label: 'Version', id: "version", value: version, disabled: true, size: 4, hide: false },
        { label: 'Region', id: "region", value: regionForCopyAndEdit, disabled: true, size: 4, hide: false },
        { label: 'Choice ID', id: "choiceId", value: choiceId, disabled: true, size: 4, hide: isModelAvailability || isDefaultLocalization || isAvailabiltyLocalization || isTOFPM || isLocChoiceId || isLocMapping },
        { label: 'Material', id: "material", value: material, disabled: true, size: 4, hide: isModelAvailability || isDefaultLocalization || isAvailabiltyLocalization || isTOFPM || isLocChoiceId || isLocMapping },
        { label: 'Material Description', id: "materialDesc", value: materialDesc, disabled: true, size: 4, hide: isModelAvailability || isDefaultLocalization || isAvailabiltyLocalization || isTOFPM || isLocChoiceId || isLocMapping },
        { label: 'Country ID', id: "countryID", value: country, size: 4, type: 'select', disabled: !copy || isFieldDisabled || readOnlyFields || isLogicalLock || isDisabledMatField, hide: isTOFPM || isLocChoiceId || isLocMapping},
        { label: 'Country Description', id: "countryDesc", value: countryDesc, disabled: true, size: 4, hide: isTOFPM || isLocChoiceId || isLocMapping },
        { label: 'Product Family', id: "productFamily", value: productFamily, disabled: copy ?!isAvailabiltyLocalization : true, type: copy &&isAvailabiltyLocalization ? 'select' : 'text', size: 4, hide: false },
        { label: 'Product Description', id: "productDesc", value: productDesc, disabled: true, size: 4, hide: !isModelAvailability && !isDefaultLocalization  },
        { label: 'Localization', id: "localization", value: localization || "ALL", size: 4, hide: !(isMaterialAvailability || isServiceAvailability), disabled: (isMaterialAvailability && !copy) || isServiceAvailability || disabledAction || isLogicalLock || (!copy && isTableRegionWW) },
        { label: 'Business Model', id: "businessModel", value: businessModel, size: 4, type: 'select', disabled: !copy || isFieldDisabled || readOnlyFields || isLogicalLock || isDisabledMatField, hide: isDefaultLocalization || isAvailabiltyLocalization || isTOFPM || isLocChoiceId || isLocMapping },
        { label: 'Product Group', id: "productGroup", value: productGroup, disabled: true, size: 4, hide: isDefaultLocalization || isAvailabiltyLocalization },
        { label: 'Feature', id: "feature", value: feature, disabled: isDefaultLocalization || isOtherRegion || isRegionalAndReadonly || isVersionRestricted || isLocExcluded , type: isAvailabiltyLocalization ? 'select' : 'text', size: 4, hide: !(isDefaultLocalization || isAvailabiltyLocalization) },
        { label: 'Feature Value', id: "featureValue", value: featureValue, disabled: isLocalization , type: isAvailabiltyLocalization ? 'select' : 'text', size: 4, hide: !(isDefaultLocalization || isAvailabiltyLocalization) },
        { label: 'LOC Feature', id: "locFeature", value: locFeature, disabled: isRegionalAndReadonly || isVersionRestricted || isKERoleForDefaultLoc, type: 'select', size: 4, hide: !isDefaultLocalization },
        { label: 'LOC Feature Value', id: "locFeatureValue", value: locFeatureValue, disabled: isRegionalAndReadonly || isVersionRestricted || isKERoleForDefaultLoc, size: 4,  type: 'select', hide: !isDefaultLocalization },
        { label: 'Feature Value Desc', id: "featureDesc", value: featureDesc, disabled: true, size: 4, hide: !isAvailabiltyLocalization },
        { label: 'Status', id: "status", value: copy ? "M" : status, disabled: true, size: 4, hide: isTOFPM || isLocChoiceId  || isLocMapping },
        { label: 'Parameter', id: "parameter", value: parameterKey, disabled: !copy || isVersionRestricted, size: 4, type: 'select', hide: !(isTOFPM || isLocChoiceId || isLocMapping) },
        { label: 'Parameter Name', id: "parameterText", value: parameterText, size: 4 , hide: !(isTOFPM || isLocChoiceId || isLocMapping), disabled: isVersionRestricted || isTOFPMRegionalDisabled || isAdminOrKE  },
        { label: 'Parameter Value', id: "parameterValue", value: parameterValue, size: 4, type: isLocChoiceId ? 'select' : 'text',  hide: !(isTOFPM || isLocChoiceId || isLocMapping), disabled: (!copy && isLocMapping) || isVersionRestricted || isTOFPMRegionalDisabled || isAdminOrKE  },
        { label: 'Regional Lock', id: "regionalLock", type: 'checkbox', value: regionLock, disabled: isRegionalLockDisabled(assignedRole,region,choiceId,isLogicalLock,selectedTableRegion) || disabledAction || isDisabledMatField, size: 4, hide: !isMaterialAvailability || regionForCopyAndEdit !== "WW"},
        { label: 'Comment', id: "comment", value: comments, multiline: true, disabled: isFieldDisabled || readOnlyFields || (isWWDatesDisabled && isWwDatesValid) || isOtherRegion || isLogicalLock || isTOFPMRegionalDisabled || isDisabledMatField || isLocExcluded || isKERole, size: 12, hide: false },
        { label: 'Who Changed', id: "whoChanged", value: copy ? userEmail : whoChanged, disabled: true, size: 12, hide: isTOFPM || isLocChoiceId || isLocMapping },
        { label: 'MS4 Start Date', id: "ms4StartDate", type: 'date', value: dayjs(ms4StartDate), disabled: true, hide: !isWwRegion || !isModelAvailability  },
        { label: 'Auto Start Date', id: "autoStartDate", type: 'date', value: dayjs(autoStart || startDate), disabled: true, hide: !isMaterialAvailability || !isWwRegion },
        { label: 'Start Date', id: "startDate", type: 'date', value: dayjs(startDateValue), minDate: isModelAvailability || isMaterialAvailability ? dayjs(ms4StartDate || autoStart) : undefined, maxDate: isModelAvailability || isMaterialAvailability ? dayjs(ms4EndDate || autoEnd) : undefined, disabled: isFieldDisabled || readOnlyFields || isWWDatesDisabled || isLogicalLock || isDisabledMatField || isLocExcluded || isMS4MaterialDatesInvalid, hide: isDatesForCopy || isServiceAvailability || isLocChoiceId || isLocMapping },
        { label: 'End Date', id: "endDate", type: 'date', value: dayjs(endDateValue), minDate: isModelAvailability || isMaterialAvailability ? dayjs(ms4StartDate || autoStart) : undefined, maxDate: isModelAvailability || isMaterialAvailability ? dayjs(ms4EndDate || autoEnd) : undefined, disabled: isFieldDisabled || readOnlyFields || isWWDatesDisabled || isLogicalLock || isDisabledMatField || isLocExcluded || isMS4MaterialDatesInvalid, hide: isDatesForCopy || isServiceAvailability || isLocChoiceId || isLocMapping },
        { label: 'Auto End Date', id: "autoEndDate", type: 'date', value: dayjs(autoEnd || endDate), disabled: true, hide: !isMaterialAvailability || !isWwRegion },
        { label: 'MS4 End Date', id: "ms4EndDate", type: 'date', value: dayjs(ms4EndDate), disabled: true, hide: !isWwRegion || !isModelAvailability },
        { label: 'WW Start Date', id: "wwStartDate", disabled: disabledAction || isDatesForCopy || readOnlyFields, type: 'date', value: dayjs(wwStartDate), hide: isDatesForCopyAndEdit || isDefaultLocalization || isTOFPM },
        { label: 'Start Date', id: "regStartDate", type: 'date', value: dayjs(invalidStartDates), minDate: dayjs(wwStartDate), maxDate: dayjs(wwEndDate), disabled: disabledAction || isDatesForCopyAndEdit || isRegionalAndReadonly || isOcplcKE || isWWDatesInvalid || readOnlyFields || isOtherRegion, hide: isDatesForCopyAndEdit || isDefaultLocalization || isTOFPM },
        { label: 'End Date', id: "regEndDate", type: 'date', value: dayjs(invalidEndDates), minDate: dayjs(wwStartDate), maxDate: dayjs(wwEndDate), disabled: disabledAction || isDatesForCopyAndEdit || isRegionalAndReadonly || isOcplcKE || isWWDatesInvalid || readOnlyFields || isOtherRegion, hide: isDatesForCopyAndEdit || isDefaultLocalization || isTOFPM },
        { label: 'WW End Date', id: "wwEndDate", disabled: disabledAction || isDatesForCopy || readOnlyFields, type: 'date', value: dayjs(wwEndDate), hide: isDatesForCopyAndEdit || isDefaultLocalization || isTOFPM },
        { label: 'Auto Start Date', id: "wwAutoStartDate", disabled: true, type: 'date', value: dayjs(wwAutoStartDate), hide: !isServiceAvailability },
        { label: 'Start Date', id: "regAutoStartDate", type: 'date', minDate: dayjs(wwAutoStartDate), maxDate: dayjs(wwAutoEndDate), value: dayjs(formData?.regAutoStartDate || startDate), hide: !isServiceAvailability, disabled: isFieldDisabled || readOnlyFields || isWWDatesDisabled || isDisabledMatField || isMS4SeriviceDatesInvalid || isKERole },
        { label: 'End Date', id: "regAutoEndDate", type: 'date', minDate: dayjs(wwAutoStartDate), maxDate: dayjs(wwAutoEndDate), value: dayjs(formData?.regAutoEndDate || endDate), hide: !isServiceAvailability, disabled: isFieldDisabled || readOnlyFields || isWWDatesDisabled || isDisabledMatField || isMS4SeriviceDatesInvalid || isKERole },
        { label: 'Auto End Date', id: "wwAutoEndDate", disabled: true, type: 'date', value: dayjs(wwAutoEndDate), hide: !isServiceAvailability },
        ...pseriesDateFields,
        { label: 'When Changed', id: "whenChanged", type: 'text', value: whenChanged , disabled: true, hide: true },
        { label: 'Last Modified Date', type: 'text', id: "lastModified", value: lastModifiedDate ? dayjs(lastModifiedDate).format("DD/MM/YYYY HH:mm") : "", disabled: true, hide: isTOFPM || isLocChoiceId || isLocMapping },
        { label: 'Create Date', type: 'text', id: "createDate", value: createDate ? dayjs(createDate).format("DD/MM/YYYY HH:mm") : "", disabled: true, hide: isTOFPM || isLocChoiceId || isLocMapping },
    ];
     const checkBoxes = [
    { label: 'AP', id: "ap", type: 'checkbox', value: isOtherMaterialRegion ? regionalCheckBoxValues.apRegion : apRegion, disabled: isCheckDisabled || isDisabledMatField || isLocExcluded || shouldDisableAllRegions, hide: isDatesForCopy || isLocChoiceId || isLocMapping },
    { label: 'EU', id: "eu", type: 'checkbox', value: isOtherMaterialRegion ? regionalCheckBoxValues.euRegion : euRegion, disabled: isCheckDisabled || isDisabledMatField || isLocExcluded || shouldDisableAllRegions, hide: isDatesForCopy || isLocChoiceId || isLocMapping },
    { label: 'LA', id: "la", type: 'checkbox', value: isOtherMaterialRegion ? regionalCheckBoxValues.laRegion : laRegion, disabled: isCheckDisabled || isDisabledMatField || isLocExcluded || shouldDisableAllRegions, hide: isDatesForCopy || isLocChoiceId || isLocMapping },
    { label: 'NA', id: "na", type: 'checkbox', value: isOtherMaterialRegion ? regionalCheckBoxValues.naRegion : naRegion, disabled: isCheckDisabled || isDisabledMatField || isLocExcluded || shouldDisableAllRegions, hide: isDatesForCopy || isLocChoiceId || isLocMapping },
    ];

        useEffect(() => {
                if (isOtherMaterialRegion) {
                    dispatch(getRegionalCheckBox(pkId));
                }
        }, [ pkId, selectedTable, selectedTableRegion]);
            
        useEffect(() => {
            if (isOtherMaterialRegion) {
                setFormData(prev => ({
                    ...prev,
                    ap: regionalCheckBoxValues.apRegion,
                    eu: regionalCheckBoxValues.euRegion,
                    la: regionalCheckBoxValues.laRegion,
                    na: regionalCheckBoxValues.naRegion,
                }));
            }
        }, [regionalCheckBoxValues, selectedTable, selectedTableRegion]);

    useEffect(() => {
        const allFields = [...renderFields, ...checkBoxes];
        const fieldValues = allFields.reduce((acc, item) => { acc[item.id] = item.value; return acc }, {})
        if (fieldValues['countryID'] === 'ALL') setIsCheckboxDisabled(false);
        setFormData(fieldValues);
        if(isAvailabiltyLocalization || isDefaultLocalization){
            dispatch(GetDefaultFeatureDropDown());
            dispatch(GetDefaultFeatureValueDropDown());
        }
        if (isTOFPM) {
            dispatch(GetParameters(region, productGroup, 'ALL'));
        }
        if (isLocChoiceId) {
            dispatch(GetParametersDropdown());
            dispatch(GetLocChoiceValue(fieldValues['parameter'], productGroup));
        }
        if (isLocMapping) {
            dispatch(GetParametersLocDropdown());
        }
    }, []);

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            regStartDate: dayjs(invalidStartDates),
            regEndDate: dayjs(invalidEndDates)
        }));
    }, [formData?.wwStartDate, formData?.wwEndDate, invalidStartDates, invalidEndDates]);

    const isUpdateButtonDisabled = () => {
        //Update button should be disabled when parameterName and parameterValue are empty
        return (isTOFPM || isLocChoiceId || isLocMapping) && (!formData?.parameterText || !formData?.parameterValue)
    }

    const validateLocalization = () => {
        return (isMaterialAvailability ) && (!formData?.localization);
    }

    const handleBlur = (field) => {
        if (field === 'parameterValue' && formData?.parameterValue && (isTOFPM || isLocChoiceId)) {
            const updatedValue = formData.parameterValue.replace(/[^A-Za-z0-9]/g, "");
            setFormData((prev) => ({
                ...prev,
                parameterValue: updatedValue
            }));
        }
        if (field === 'localization' && formData?.localization && isMaterialAvailability) {
            const updatedValue = formData.localization.replace(/[^A-Za-z0-9]/g, "");
            setFormData((prev) => ({
                ...prev,
                localization: updatedValue
            }));
        }
    };

    const applyDummyDateToAllRanges = (data) => {
        const updated = { ...data };

        // reg dates
        updated.regStartDate = dayjs(DUMMY_DATE);
        updated.regEndDate = dayjs(DUMMY_DATE);

        // p-series / regionalFields dates
       regionalFields.forEach(({ startField, endField }) => {
        if (startField) {
            const isValidStartDate = data[startField];
            // if it has a valid date (not blank and not 01/01/9999)
            if (isValidStartDate && dayjs(isValidStartDate).isValid() && !dayjs(isValidStartDate).format().startsWith(DUMMY_DATE)) {
                updated[startField] = dayjs(DUMMY_DATE);
            }
        }
        if (endField) {
            const isValidEndDate = data[endField];
            if (isValidEndDate && dayjs(isValidEndDate).isValid() && !dayjs(isValidEndDate).format().startsWith(DUMMY_DATE)) {
                updated[endField] = dayjs(DUMMY_DATE);
            }
        }
    });

    return updated;
};

    const isDummyDate = (date) =>
        date && dayjs(date).format().startsWith(DUMMY_DATE);

    const clearDummyRegionalDates = (data) => {
        const updated = { ...data };

        const bothRegReal =
            !isDummyDate(updated.regStartDate) &&
            !isDummyDate(updated.regEndDate);

        if (bothRegReal) {
            regionalFields.forEach(({ startField, endField }) => {
                if (startField && isDummyDate(updated[startField])) {
                    updated[startField] = "";
                }
                if (endField && isDummyDate(updated[endField])) {
                    updated[endField] = "";
                }
            });
        }

        return updated;
    };


    const handleChange = async (event, field, type) => {
        let value;
        if (type === 'checkbox') {
            value = event.target.checked;
        } else if (type === 'date') {
            value = event ? dayjs(event) : "";
        } else {
            value = event.target.value;
        }
        if (isLocChoiceId && (field === "parameter")) {
            const res = await dispatch(GetLocChoiceName(value, productGroup));
            dispatch(GetLocChoiceValue(value, productGroup));
            formData['parameterText'] = res[0]?.value || '';
            formData['parameterValue'] = '';
        }
        let updatedData = { ...formData, [field]: value };

        if (type === 'date' && (field === 'regStartDate' || field === 'regEndDate')) {
            const wasDummy =
                isDummyDate(formData.regStartDate) ||
                isDummyDate(formData.regEndDate);

            const isNowDummy = isDummyDate(value);

            // Case 1 User selects 01/01/9999
            if (isNowDummy) {
                updatedData = applyDummyDateToAllRanges(updatedData);
            }

            // Case 2️ User changes FROM 9999 to real date
            if (wasDummy && !isNowDummy) {
                updatedData = clearDummyRegionalDates(updatedData);
            }
        }

        if(type === 'date' && (field === 'startDate' || field === 'endDate')) {
            const isNowDummy = isDummyDate(value);
                // If user changes either of the WW dates to 01/01/9999, set both to 01/01/9999
            if (isNowDummy) {
                updatedData.startDate = dayjs(DUMMY_DATE);
                updatedData.endDate = dayjs(DUMMY_DATE);
            }
        }

        if( type === 'date' && (field === 'regAutoStartDate' || field === 'regAutoEndDate') && isServiceAvailability){
            const isNowDummy = isDummyDate(value);
            if(isNowDummy){
                updatedData.regAutoStartDate = dayjs(DUMMY_DATE);
                updatedData.regAutoEndDate = dayjs(DUMMY_DATE);
            }
        }

        if (type === 'select' && selectedTableRegion !== "WW" && isModelAvailability) {
            const res = await dispatch(
                getRegionalWWDates(
                    updatedData.productFamily,
                    updatedData.productGroup,
                    updatedData.countryID,
                    updatedData.businessModel
                )
            );
            if (Object.keys(res).length > 0) {
                updatedData = {
                    ...updatedData,
                    wwStartDate: dayjs(res.wWStartDate),
                    wwEndDate: dayjs(res.wWEndDate),
                };
                setIsInsertDisabled(false);
            }
            else {
                setIsInsertDisabled(true);
            }
        }
        updatedData = updateCountryData(updatedData, field, value, countryList, setIsCheckboxDisabled, selectedTable);
        setFormData(updatedData);
    };
    const renderCountryAndBusinessSelect = useCallback((id, field, type, disabled) => {
        const isCountry = field === 'Country ID';
        const isLocalizationFeature = field === 'LOC Feature' || field === 'Feature';
        const isParameters = isTOFPM && field === 'Parameter';
        const isLocChoiceID = isLocChoiceId && field === 'Parameter';
        const isLocChoiceValue = isLocChoiceId && field === 'Parameter Value';
        const isLocMappingKey = isLocMapping && field === 'Parameter';
        const isLocalizationFeatureValue = field === 'LOC Feature Value' || field === 'Feature Value';
        const isAvaliableLocProductFamily = copy && isAvailabiltyLocalization && field === 'Product Family';                
        const dropdownList = isCountry ? countryList :
            isLocalizationFeature ? defaultFeatureDropdown :
            isAvaliableLocProductFamily? filterOcplcKmatForPG :
                isLocalizationFeatureValue ? defaultFeatureValueDropdown :
                    isParameters ? parametersDropdown :
                        isLocChoiceID ? localizationChoice :
                            isLocChoiceValue ? localizationChoiceValue :
                                isLocMappingKey ? localizationMapping :
                                businessModels;
        const disabledAction = !isLocalization && ((field === 'Business Model' && businessModel !== 'ALL') || (field === 'Country ID' && country !== 'ALL'));
        const dropdownLists = Array.isArray(dropdownList) ? dropdownList : [];
        return (
            <FormControl fullWidth>
                <Select
                    value={formData[id] || ''}
                    onChange={(e) => handleChange(e, id, type)}
                    disabled={disabled || disabledAction}
                >
                    {dropdownLists.length ? (
                        dropdownLists.map((item, index) => {
                            const { countryCode, value, text, kmatId } = typeof item === "object" ? item : { value: item, text: item, countryCode: item, kmatId: item };
                            return (
                                <MenuItem key={index} value={countryCode || value || kmatId}>
                                    {(copy && isAvailabiltyLocalization && kmatId) ? kmatId :((isLocalization || isLocChoiceId || isLocMapping || isTOFPM ) && value) || countryCode || `${value}  | ${text}`}
                                </MenuItem>
                            );
                        })
                    ) : (
                        <MenuItem disabled>No items available</MenuItem>
                    )}
                </Select>
            </FormControl>
        );
    },
        [formData, handleChange, disabledAction, countryList, businessModels]
    );

    const renderDateCheckboxTextField = useCallback((field, index) => {
        const { label, type, disabled, multiline, id, size = 3, minDate, maxDate, tooltip = false } = field;
        const value = formData[id];
        return (
            <Grid size={size} key={index}>
                <Typography sx={{ fontSize: "14px", color: "black" }}>{label}</Typography>
                {type === "date" ? (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Tooltip
                            title={disabled && tooltip ? "TOF fields are disabled due to invalid WW or regional date configuration." : ""}
                            arrow
                            placement="top"
                        >
                            <span style={{ display: "inline-block", width: "100%" }}>
                                <DatePicker
                                    disabled={disabled}
                                    value={value ? dayjs(value) : null}
                                    onChange={(date) => handleChange(date, id, type)}
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    format="DD/MM/YYYY"
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            error: false,
                                            variant: "outlined",
                                        },
                                    }}
                                />
                            </span>
                        </Tooltip>
                    </LocalizationProvider>
                ) : type === "checkbox" ? (
                    <FormControlLabel control={<Checkbox disabled={disabled} checked={!!value} onChange={(e) => handleChange(e, id, type)} />} />
                ) : type === "select" ? (
                    renderCountryAndBusinessSelect(id, label, type, disabled)
                ) : (
                    <TextField
                        fullWidth
                        disabled={disabled}
                        multiline={multiline}
                        minRows={3}
                        value={value || ""}
                        onBlur={() => handleBlur(id)}
                        onChange={(e) => handleChange(e, id, type)}
                        className={classes.textField}
                    />
                )}
            </Grid>
        );
    },
        [formData, handleChange]
    );

      const onSaveChange = (e) => {
        e.preventDefault();
        setLocalizationError("");
        if (isMaterialAvailability && formData['localization'] && formData['localization'].length !== 3) {
                setLocalizationError("Localization code must be 3 characters - alpha numeric.");
                return;
            }
    
        const isOtherRegion = selectedTableRegion !== "WW";
    
        if (isMaterialAvailability) {
            if (copy) {
                const action = isOtherRegion
                    ? copyRegionForMaterialAvailability
                    : createCopyAvailability;
                if(formData.regionalLock){
                    getFormData(formData)
                    getConfirmationDialog({open: true, message:COMPLETE_WARNING_MESSAGE, onConfirm: () => {
                        dispatch(action(formData, plcDetails, handleClose, setCheckedRows, productLineID, kmatId,setSelectedIds, selectedCategory, selectedTableRegion, productGroupDashboard));
                    }})
                }else{
                    dispatch(action(formData, plcDetails, handleClose, setCheckedRows, productLineID, kmatId,setSelectedIds, selectedCategory, selectedTableRegion, productGroupDashboard));
                }
            } else {
                if(formData.regionalLock){
                    setConfirmationDialog({open: true, message: COMPLETE_WARNING_MESSAGE, onConfirm: () => {
                        dispatch(updateMaterialAvailability(formData, plcDetails, userEmail, handleClose, setCheckedRows, selectedCategory, selectedTableRegion, kmatId, productGroupDashboard,setSelectedIds));
                        setConfirmationDialog({ open: false, message: '', onConfirm: null });
                    }});
                }else{
                    dispatch(updateMaterialAvailability(formData, plcDetails, userEmail, handleClose, setCheckedRows, selectedCategory, selectedTableRegion, kmatId, productGroupDashboard,setSelectedIds));
                }
            }
        } else {
            if (isModelAvailability) {
                dispatch(updateModelAvailability(formData, plcDetails, userEmail, isOtherRegion, regionForCopyAndEdit, copy, kmatId, productLineID, selectedTableRegion, handleClose, setCheckedRows, isWwStartDateEdited, isWwEndDateEdited, isRegStartDateEdited, isRegEndDateEdited,setSelectedIds));
            }
        }
        if (isServiceAvailability) {
            dispatch(updateServiceAvailability(formData, plcDetails, userEmail, handleClose, setCheckedRows, productLineID, copy, productGroupDashboard, kmatId,setSelectedIds));
        }
        if (isDefaultLocalization) {
            dispatch(updateDefaultLocalization(formData, plcDetails, userEmail, copy, handleClose, setCheckedRows, kmatId,setSelectedIds));
        }
        if (isAvailabiltyLocalization) {
            dispatch(updateAvailabilityLocalization(formData, plcDetails, userEmail, copy, handleClose, setCheckedRows, isOtherRegion, regionForCopyAndEdit, kmatId,setSelectedIds));
            }
            if (isTOFPM) {
                // Dispatch TOF Program Management update action here
                dispatch(updateTOFProgramManagement(formData, plcDetails, userEmail, copy, handleClose, setCheckedRows,setSelectedIds));
            }
            if(isLocChoiceId){
                dispatch(updateLocChoiceId(formData, plcDetails, userEmail, copy, handleClose, setCheckedRows, setSelectedIds));
            }
            if(isLocMapping){
                dispatch(updateLocMapping(formData, plcDetails, userEmail, copy, handleClose, setCheckedRows, setSelectedIds));
            }
    };

    const DialogContentComponent = (
        <>
            <DialogContent>
                <Typography sx={{ marginBottom: "12px", wordBreak: "break-all" }} variant="h5">{copy ? 'COPY' : isMaterialAvailability || isServiceAvailability ? `${materialDesc} ${materialDesc && "-"}  ${productFamily}` :isAvailabiltyLocalization || isTOFPM || isLocChoiceId || isLocMapping ? `${productFamily}` : `${productDesc} ${productDesc && "-"}   ${productFamily}`}</Typography>
                <Grid container spacing={2}>
                    {renderFields.map((field, index) => !field.hide && renderDateCheckboxTextField(field, index))}
                </Grid>
                <Grid container spacing={2} sx={{ marginTop: "10px" }} >
                    {checkBoxes.map((field, index) => !field.hide && renderDateCheckboxTextField(field, index))}
                </Grid>
            </DialogContent>
            <DialogActions sx={{ marginTop: "20px" }} className='dialog-actions'>
                <Grid size={12} container direction="column" margin={2}>   
                    {localizationError && <Typography color="error" sx={{ mb: 1 }}>{localizationError}</Typography>}
                <Grid container justifyContent="flex-end">
                    <Button variant="outlined" onClick={handleClose} className="cancel-button">Cancel</Button>
                    <Button variant="contained" color="primary" sx={{ marginLeft: 1 }} disabled={isFieldDisabled || readOnlyFields || isInsertDisabled || isOtherRegion || isLogicalLock || isTOFPMRegionalDisabled || isUpdateButtonDisabled() || validateLocalization() || isDisabledMatField || isLocExcluded || isKERole} className="add-Button" onClick={onSaveChange}>{copy ? 'Insert' : 'Update'}</Button>
                </Grid>
                </Grid>
            </DialogActions>
        </>
    );

    return copy ? (
        <Dialog open={open} onClose={handleClose} sx={{ borderRadius: "10px" }} maxWidth="md" fullWidth>
            {DialogContentComponent}
        </Dialog>
    ) : (
        <>
            <Drawer anchor="right" open={open} onClose={handleClose}>
                <Box sx={{ width: 850 }}>
                    {DialogContentComponent}
                </Box>
            </Drawer>
            {confirmDialog.open && (
                <ConfirmationDialog
                    open={confirmDialog.open}
                    content={confirmDialog.message}
                    onConfirm={confirmDialog.onConfirm}
                    onClose={() => setConfirmationDialog({ open: false, message: '', onConfirm: null })}
                    caption="Confirm"
                    bgColor="#1976d2"
                />  
            )}
        
        </>
    );
}

export default EditOcplc;
